import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/planificadorFormulario/importer/planificadorFormularioImporterActions';

export default importerReducers(actions);
